<template>
  <div>
    <div v-if="jobDetailsAvailable">
      <v-card
        v-for="(item, index) in jobDetails.sub_jobs"
        :key="index"
        color="#FFF"
        dark
        class="card-style pa-3"
        elevation="0"
        @click.stop
        @click="subJobDetails(item.external_id)"
      >
        <template v-if="confirmingJobId === item.external_id">
          <v-card-text class="text-center">
            <p class="mb-4">
              Are you sure you want to update the progress of
              {{ projectName }} to {{ tempProgress }}% ?
            </p>
            <v-btn
              small
              color="green"
              @click.stop="confirmUpdate(item)"
            >
              Yes
            </v-btn>
            <v-btn
              small
              color="red"
              outlined
              class="ml-2"
              @click.stop="cancelUpdate(item)"
            >
              No
            </v-btn>
          </v-card-text>
        </template>
        <template v-else>
          <v-card-text>
            <div class="content-wrapper">
              <h3 color="#000">
                {{ item.name }}
              </h3>
              <v-chip
                dark
                color="transparent"
                small
                elevation="0"
                label
                class="text-format"
              >
                <v-icon
                  x-small
                  :color="cardColor(item.priority)"
                  class="pr-1"
                >
                  mdi-circle
                </v-icon>
                {{ item.priority }}
              </v-chip>
            </div>
            <div class="content-wrapper">
              <p class="title-text-style">
                <font v-if="jobDetails.project && jobDetails.project.name">
                  {{ jobDetails.project.name }}
                </font>
                <font v-else>
                  N/A
                </font>
              </p>
            </div>
            <div class="content-wrapper">
              <span class="title-text-style">
                <v-icon
                  color="#37474F"
                  size="20"
                >
                  mdi-account-check
                </v-icon>
                <font v-if="item.assigned_to_name !== null">
                  {{ item.assigned_to_name }}
                </font>
                <font v-else> N/A</font>
              </span>
            </div>
            <div class="d-flex justify-content-center align-center">
              <v-slider
                v-model="item.progress"
                :max="100"
                :min="0"
                step="1"
                color="blue-grey"
                thumb-size="12"
                hide-details
                dense
                class="flex-grow-1"
                @change="confirmUpdate(item)"
              />

              <b class="black--text ml-2">{{ Math.ceil(item.progress) }}%</b>
            </div>

            <div class="time-style">
              <p>
                <v-icon
                  color="green"
                  size="18"
                >
                  mdi-calendar-start
                </v-icon>
                <font
                  v-if="item.actual_start_date !== null"
                  class="value-text-style"
                  style="text-transform: uppercase"
                >
                  {{ item.actual_start_date | convertToLocal }}
                </font>
                <font
                  v-else
                  class="value-text-style"
                  style="text-transform: uppercase"
                >
                  {{ item.planned_start_date | convertToLocal }}
                </font>
              </p>
              <p>
                <v-icon
                  color="red"
                  size="18"
                >
                  mdi-calendar-end
                </v-icon>
                <font
                  v-if="item.actual_end_date !== null"
                  class="value-text-style"
                  style="text-transform: uppercase"
                >
                  {{ item.actual_end_date | convertToLocal }}
                </font>
                <font
                  v-else
                  class="value-text-style"
                  style="text-transform: uppercase"
                >
                  {{ item.planned_end_date | convertToLocal }}
                </font>
              </p>
            </div>
            <div class="content-wrapper align-center">
              <!-- <v-chip
                      dark
                      rounded
                      outlined
                      color="#e6e6e6"
                      small
                      class="status-style"
                    >
                      {{ item.status }}
                    </v-chip> -->
              <div>
                <v-menu
                  ref="statusMenu"
                  offset-y
                  :close-on-content-click="true"
                  :nudge-width="0"
                  content-class="status-menu"
                  attach
                >
                  <template #activator="{ on, attrs }">
                    <div
                      class="status-activator"
                      v-bind="attrs"
                      v-on="on"
                      @click.stop
                    >
                      <v-chip
                        small
                        :color="statusColor(getStatusObject(item).id)"
                        dark
                        label
                        class="ma-0 "
                      >
                        <font
                          color="#fff"
                        >
                          {{ getStatusObject(item).title }}
                          <v-icon
                            small
                            class="status-chevron"
                          >
                            mdi-menu-down
                          </v-icon>
                        </font>
                      </v-chip>
                    </div>
                  </template>
                  <v-list
                    dense
                    class="ma-0 pa-0"
                  >
                    <v-list-item
                      v-for="(s, sindex) in statusList"
                      :key="s.id"
                      @click.stop="changeStatus(item, s, sindex)"
                    >
                      <v-list-item-content class="pt-0 pb-0">
                        <v-chip
                          small
                          :color="statusColor(s.id)"
                          light
                          label
                          class="ma-0"
                        >
                          <font color="#fff">
                            {{ s.title }}
                          </font>
                        </v-chip>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div class="button-group">
                <v-btn
                  small
                  elevation="0"
                  style=""
                  light
                  @click.stop
                  @click="jobComments(item.external_id)"
                >
                  <v-icon small>
                    mdi-plus
                  </v-icon>
                  <span style="text-transform: capitalize">add notes</span>
                </v-btn>
              </div>
            </div>
            <!-- <font color="#000" cl>Project: Hospital Construction Sydney </font> -->
          </v-card-text>
        </template>
      </v-card>
      <br>
      <br>
      <br>
      <br>
    </div>
    <div
      v-else
      class="empty-alert-div mt-5"
    >
      <v-card
        color="#FFF"
        elevation="0"
      >
        <br>
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>No
          sub tasks found
        </p>
        <br>
        <br>
      </v-card>
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment';
export default {
  name: 'SubJobs',
  components: {
    'centre-spinner': spinner,
  },
  filters: {
    convertToLocal (stringDatetime) {
      return moment.utc(stringDatetime).local().format('D, ddd hh:mm A');
    },
  },
  data: () => ({
    loading: false,
    confirmingJobId: null,
    tempProgress: null,
    projectName: null,
    statusList: [
      {
        title: 'ACTIVE',
        id: 'active',
      },
      {
        title: 'PENDING',
        id: 'pending',
      },
      {
        title: 'COMPLETED',
        id: 'completed',
      },
    ],
  }),
  computed: {
    jobDetails () {
      return this.$store.getters['jobs/getJobDetails'];
    },
    jobDetailsAvailable () {
      if (Object.keys(this.jobDetails).length !== 0) {
        if (this.jobDetails.sub_jobs.length !== 0) {
          return true;
        }
        return false;
      }
      return false;
    },
  },
  methods: {
    subJobDetails (id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ path: `/jobs/${id}/details` });
        this.loading = false;
      }, 1000);
    },
    askConfirm (item) {
      this.confirmingJobId = item.external_id;
      this.tempProgress = item.progress;
      this.projectName = item.name;
    },

    async confirmUpdate (item) {
      this.loading = true;
      await this.$store.dispatch('jobs/saveProgress', {
        formData: {
          progress: String(item.progress),
          status: item.status,
        },
        jobId: item.external_id,
      });
      this.loading = false;

      // reset confirmation state
      this.confirmingJobId = null;
      this.tempProgress = null;
      this.projectName = null;
    },
    getStatusObject (item) {
      if (!item) return { id: '', title: '' };
      if (item.status && typeof item.status === 'object') return item.status;
      const found = this.statusList.find((s) => s.id === item.status);
      return (
        found || {
          id: item.status || '',
          title: String(item.status || '').toUpperCase(),
        }
      );
    },

    async changeStatus (item, statusObj, sindex) {
      this.$set(item, 'status', statusObj.id);
      await this.updateStatus(item, statusObj.id);

      // Close the correct menu by index
      if (this.$refs.statusMenu && this.$refs.statusMenu[sindex]) {
        this.$refs.statusMenu[sindex].isActive = false;
      }
    },

    async updateStatus (item, statusValue) {
      this.loading = true;
      try {
        await this.$store.dispatch('jobs/saveProgress', {
          formData: {
            progress: String(item.progress),
            status: statusValue,
          },
          jobId: item.external_id,
        });
      } finally {
        this.loading = false;
      }
    },
    statusColor (val) {
      if (val === 'active') return 'green';
      if (val === 'pending') return 'orange';
      if (val === 'completed') return 'blue';
      return 'grey';
    },
    cardColor (val) {
      if (val === 'low') {
        return 'green';
      } else if (val === 'medium') {
        return 'yellow';
      } else if (val === 'high') {
        return 'orange';
      } else {
        return 'red';
      }
    },
    cancelUpdate (item) {
      this.confirmingJobId = null;
      this.tempProgress = null;
      this.projectName = null;
    },
    jobComments (id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ path: `/jobs/${id}/comments` });
        this.loading = false;
      }, 1000);
    },
  },
};
</script>

<style scoped>
.card-style {
  border-radius: 10px;
  margin-top: 20px;
  background: #fff !important;
}

.time-style .value-text-style {
  font-size: 12px;
}

.time-style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 6px;
}

.empty-alert-msg {
  padding: 12px;
}

.button-group {
  justify-content: flex-end;
  display: flex;
  gap: 15px;
}

.chat-button {
  border: 1px solid #37474f !important;
}
::v-deep(.chat-button .v-icon) {
  color: #fff !important;
}

.v-expansion-panel-header {
  padding: 0px 10px 0px 0px !important;
}
.status-activator {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

/* chip size */
.status-activator .v-chip {
  height: 28px;
  font-size: 12px;
  line-height: 18px;
}

.status-activator .status-chevron {
  font-size: 25px !important;
  color: #e6e6e6; /* adjust as needed */
  opacity: 1;
}

/* compact menu items */
::v-deep(.status-menu .v-list-item) {
  min-height: 28px !important;
  padding: 4px 8px !important;
}

.text-format {
  text-transform: capitalize;
}
.content-wrapper {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
</style>
